import React from 'react';
import { connect } from 'react-redux';

import { Theme, createStyles, withStyles } from '@material-ui/core';
import AddBox from '@material-ui/icons/AddBox';
import InfoIcon from '@material-ui/icons/Info';
import { FormControl, InputLabel } from '@material-ui/core';

import style from '../commonComponentsStyle.module.css';
import DeliveryCompany from '../../../models/DeliveryCompany';
import ForwarderModel from '../../../models/ForwarderAwb';
import Select from 'react-select';
import TruckDriverData from '../../../models/TruckDriverData';


const iconFontSize = 40;
const useStyles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    formControl: {
      width: '350px',
      marginRight: '10px',
      marginTop: '5px',
    },
    formControlFWd: {
      width: '86%',
    },
    selectcss:{
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control':{
        borderColor: 'inherit',
        borderRadius: 'var(--ip-br)',
        fontSize: '14px',
        minHeight: '31px !important',
        boxShadow: 'none',
        '&:hover':{
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator':{
        display: 'none'
      }
    },
    label: {
      minWidth: '355px'
    },
    selectLabel: {
      transform: 'translate(14px, 29px) scale(1) ',
      color: 'var(--primaryblue)',
    },
    shrinkLabel: {
      transform: 'translate(14px, 10px) scale(0.75) !important',
    },
    selectLabelError: {
      transform: 'translate(14px, 29px) scale(1) ',
      color: 'red'
    },
    shrinkLabelError: {
      transform: 'translate(14px, 10px) scale(0.75) !important',
      color: 'red'
    },
    select: {
      border: '1px solid var(--primaryblue)', 
      borderRadius:'5px',
      fontSize: '14px',
      minHeight: '35px'
    },
    styleInputProps: {
      color: 'var(--primaryblue)', 
      fontSize: '0.8125rem'
    },
    helperText: {
      color: 'red',
      marginLeft: '10px'
    }
  });

interface DriverDropDownProps {
  classes: any;
  items: Array<TruckDriverData | ForwarderModel>;
  value: number | undefined ;
  openModal: () => void;
  allowedToChange?: boolean;
  onChange: (event: any) => void;
  valiant?: string ;
  labelText: string;
  type: 'truckingCompany' | 'fwdCompany';
  error?: string;
  onClick?: (event: any) => void;
  hasCreateNewCompany?: boolean;
  isEditMode: boolean;
};

interface Option {
  value: number;
  label: string;
};

const driverDropDown = (props: DriverDropDownProps) => {

  const { classes } = props;
  const options: Array<Option> = props.items.map((item: any) => (
    {
      value: item.id,
      label: item.name
    }
  ));

  const getForwarderValue = (): Option => {
   const value: Array<Option> = options.filter((fwd: any) => fwd.value === props.value);
   return value[0];
  }

  const disabled = (props.type === 'truckingCompany' && !props.allowedToChange)?  true : false;
  const onClick = (props.type === 'truckingCompany')? (props.allowedToChange ? props.openModal : undefined ) : props.openModal;
  const dropDownWrapper: string = props.type === 'truckingCompany' ? style.dropDownTruckWrapper : style.dropDownFwdWrapper;
  const shrink: boolean = props.type === 'fwdCompany' ? (props.value ? true : false) : true;
  const formControl: string = props.type === 'fwdCompany' ? classes.formControlFWd : classes.formControl;
  const styleSelect:  string = props.type === 'fwdCompany' ? classes.select : '';
  const styleLabel: string = props.type === 'fwdCompany' ? ( props.error ? classes.selectLabelError : classes.selectLabel ) : classes.label;
  const shrinkLabel: string = props.type === 'fwdCompany' ? (props.error ? classes.shrinkLabelError :  classes.shrinkLabel) : '';
  const selectValue: any = props.value ? getForwarderValue() : null;
  return (
      <div className={ dropDownWrapper }>
        <FormControl
          required={ !props.isEditMode }
          className= { `${ formControl } ${ classes.selectcss }` } >
          <div className={ style.info }><InfoIcon color="primary" className={ style.materialIcon } />Select driver or create new using "+"</div>
          <Select 
            onChange={ props.onChange }
            isDisabled={ disabled || props.isEditMode }
            options={ options }
            className={ styleSelect }
            value={ selectValue  }
            placeholder={ props.labelText }
            onClick={ props.onClick }
          />
        </FormControl>
        { !props.hasCreateNewCompany && !props.isEditMode &&
          <div className={ style.buttonWrapper }>
            <AddBox color="primary" className={ classes.materialIcon } onClick={ onClick } />
          </div>
        }
      </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isEditMode: state.manualEntryEdit.isEditMode
  }
}
  
export default withStyles(useStyles)(connect(mapStateToProps, {})(driverDropDown));
